'use client';

import { ProjectModel } from '@/lib/models/Project';
import HomeContent from '@/components/Desktop/HomeContent';
import HomeMobile from '@/components/Mobile/Home';
import { useIsMobile } from '@/components/DeviceContext';

interface Props {
  projects: ProjectModel[];
}

export default function HomePageContent({ projects }: Props) {
  const isMobile = useIsMobile();
  return isMobile
    ? <HomeMobile projects={projects} />
    : <HomeContent projects={projects} />;
}
